import { c as _c } from "react/compiler-runtime";
import React, { useState, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import BrowserOnly from 'components/consumer/BrowserOnly';
import PDPView3DButton from 'components/consumer/PDP/PDPView3DButton';
import RatioContainer from 'components/consumer/RatioContainer';
import JBProductImage from 'components/essentials/JBImage/JBProductImage';
import PDPFullScreenGallery from 'components/consumer/PDP/PDPFullScreenGallery';
import PDPMobileGalleryZoomIcon from 'components/consumer/PDP/PDPMobileGalleryZoomIcon';
import PDPFavoriteButton from 'components/consumer/PDPFavoriteButton';
import CSSScrollSnapCarousel from 'components/consumer/CSSScrollSnapCarousel';
import scrollIntoViewUtil from 'commons/scrollIntoViewUtil';
import { markLuxPageNavigationEnd } from 'commons/lux';
import useRemoveBrokenImageUrls from 'global-state/brokenImageUrls/useRemoveBrokenImageUrls';
import PDPProductIntroVideo from '../PDPDesktopHeroGallery/PDPProductIntroVideo';
import { getMainImageImgixPropsForPhoto } from '../PDPDesktopHeroGallery/helpers/imgix-props';
import PDPShownIn from '../PDPShownIn';

// Return items that have a unique id or videoId field
const getUniqueCarouselItems = items => {
  const uniqueItems = [];
  const seenIds = new Set();
  items.forEach(item => {
    const id = item.id || item.videoId;
    if (id && !seenIds.has(id)) {
      seenIds.add(id);
      uniqueItems.push(item);
    }
  });
  return uniqueItems;
};
const DEFAULT_PHOTOS = [];
const PDPMobileCarousel = t0 => {
  const $ = _c(89);
  const {
    displayShownIn: t1,
    enableCrops: t2,
    headerLeft,
    isConfigFlipped: t3,
    isEditOrder: t4,
    isHero: t5,
    maxPhotos: t6,
    onAfterSlide,
    photos: t7,
    productName,
    rightButtons,
    showARIcon: t8,
    showDecideLaterOverlay: t9,
    showFavoriteButton: t10,
    videoId,
    zoomOnClick: t11
  } = t0;
  const displayShownIn = t1 === undefined ? false : t1;
  const enableCrops = t2 === undefined ? true : t2;
  const isConfigFlipped = t3 === undefined ? false : t3;
  const isEditOrder = t4 === undefined ? false : t4;
  const isHero = t5 === undefined ? false : t5;
  const maxPhotos = t6 === undefined ? 16 : t6;
  const photos = t7 === undefined ? DEFAULT_PHOTOS : t7;
  const showARIcon = t8 === undefined ? false : t8;
  const showDecideLaterOverlay = t9 === undefined ? false : t9;
  const showFavoriteButton = t10 === undefined ? false : t10;
  const zoomOnClick = t11 === undefined ? true : t11;
  const validPhotos = useRemoveBrokenImageUrls(photos);
  const isConfigurationGallery = validPhotos?.[0]?.type === "configuration" || validPhotos?.[0]?.type === "cylindo";
  const [isFullScreenGalleryOpen, setIsFullScreenGalleryOpen] = useState(false);
  const [selectedCarouselIndex, setSelectedCarouselIndex] = useState(0);
  let t12;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {};
    $[0] = t12;
  } else {
    t12 = $[0];
  }
  const [brokenImages, setBrokenImages] = useState(t12);
  const hasMoreThanMaxPhotos = validPhotos.length > maxPhotos;
  let t13;
  if ($[1] !== hasMoreThanMaxPhotos || $[2] !== maxPhotos || $[3] !== validPhotos || $[4] !== videoId) {
    const trimmedPhotos = hasMoreThanMaxPhotos ? validPhotos.slice(0, maxPhotos) : validPhotos;
    t13 = videoId && trimmedPhotos.length ? [trimmedPhotos[0], {
      videoId
    }, ...trimmedPhotos.slice(1)] : trimmedPhotos;
    $[1] = hasMoreThanMaxPhotos;
    $[2] = maxPhotos;
    $[3] = validPhotos;
    $[4] = videoId;
    $[5] = t13;
  } else {
    t13 = $[5];
  }
  const photosAndVideo = t13;
  const carouselPhotos = photosAndVideo;
  const standardRatio = isConfigurationGallery ? 0.6666666666666666 : 0.5;
  let t14;
  if ($[6] !== displayShownIn) {
    t14 = () => {
      if (!displayShownIn) {
        return;
      }
      scrollIntoViewUtil("[data-xc=\"PDPMobileConfigurationPhotoGalleryUI\"]", 0);
    };
    $[6] = displayShownIn;
    $[7] = t14;
  } else {
    t14 = $[7];
  }
  const scrollDownToCustomizer = t14;
  let t15;
  if ($[8] !== onAfterSlide) {
    t15 = slideIndex => {
      setSelectedCarouselIndex(slideIndex);
      onAfterSlide?.(slideIndex);
    };
    $[8] = onAfterSlide;
    $[9] = t15;
  } else {
    t15 = $[9];
  }
  const handleSlideChange = t15;
  let t16;
  if ($[10] !== carouselPhotos) {
    t16 = getUniqueCarouselItems(carouselPhotos);
    $[10] = carouselPhotos;
    $[11] = t16;
  } else {
    t16 = $[11];
  }
  const uniqueCarouselPhotos = t16;
  let t17;
  if ($[12] !== brokenImages || $[13] !== displayShownIn || $[14] !== enableCrops || $[15] !== hasMoreThanMaxPhotos || $[16] !== isConfigFlipped || $[17] !== isConfigurationGallery || $[18] !== isEditOrder || $[19] !== isHero || $[20] !== productName || $[21] !== scrollDownToCustomizer || $[22] !== showDecideLaterOverlay || $[23] !== standardRatio || $[24] !== uniqueCarouselPhotos || $[25] !== validPhotos.length || $[26] !== zoomOnClick) {
    let t18;
    if ($[28] !== brokenImages || $[29] !== displayShownIn || $[30] !== enableCrops || $[31] !== hasMoreThanMaxPhotos || $[32] !== isConfigFlipped || $[33] !== isConfigurationGallery || $[34] !== isEditOrder || $[35] !== isHero || $[36] !== productName || $[37] !== scrollDownToCustomizer || $[38] !== showDecideLaterOverlay || $[39] !== standardRatio || $[40] !== uniqueCarouselPhotos.length || $[41] !== validPhotos.length || $[42] !== zoomOnClick) {
      t18 = (t19, index) => {
        const {
          src,
          id,
          type,
          cropData,
          videoId: videoId_0,
          optionId,
          upholsteryName,
          valueId
        } = t19;
        const slideKey = videoId_0 ? `video-${videoId_0}` : `${id || src || index}`;
        return {
          key: slideKey,
          slide: <RatioContainer className={classNames({
            "pt-8 px-6 pb-11": isConfigurationGallery && !enableCrops,
            "scale-x-[-1]": isConfigurationGallery && isConfigFlipped,
            "flex justify-center": brokenImages[src]
          })} ratio={enableCrops ? 1 : standardRatio}>{index === 1 && videoId_0 ? <PDPProductIntroVideo videoId={videoId_0} /> : <>{displayShownIn ? <PDPShownIn isEditOrder={isEditOrder} optionId={optionId} upholsteryName={upholsteryName} valueId={valueId} layout="roundSwatchLabel" onSelection={scrollDownToCustomizer} productName={productName} showInactiveUpholstery={true} /> : null}<JBProductImage className="h-full object-contain w-full" {...getMainImageImgixPropsForPhoto({
                src,
                type,
                cropData
              }, enableCrops)} lazy={index !== 0} sizes="100vw" onClick={zoomOnClick ? showDecideLaterOverlay ? _temp : () => {
                setSelectedCarouselIndex(index);
                setIsFullScreenGalleryOpen(true);
              } : undefined} forPage="pdp" onLoad={isFail => {
                if (index === 0 && isHero) {
                  markLuxPageNavigationEnd();
                }
                if (!isFail) {
                  return;
                }
                setBrokenImages({
                  ...brokenImages,
                  [src]: true
                });
              }} /></>}{hasMoreThanMaxPhotos && index === uniqueCarouselPhotos.length - 1 && <div className="items-center bottom-0 flex justify-center left-0 pointer-events-none absolute right-0 top-0"><div className="text-lg font-bold bg-brand-lightest text-brand-dark px-4 py-3">Explore{" "}{validPhotos.length - uniqueCarouselPhotos.length}+ more photos</div></div>}</RatioContainer>
        };
      };
      $[28] = brokenImages;
      $[29] = displayShownIn;
      $[30] = enableCrops;
      $[31] = hasMoreThanMaxPhotos;
      $[32] = isConfigFlipped;
      $[33] = isConfigurationGallery;
      $[34] = isEditOrder;
      $[35] = isHero;
      $[36] = productName;
      $[37] = scrollDownToCustomizer;
      $[38] = showDecideLaterOverlay;
      $[39] = standardRatio;
      $[40] = uniqueCarouselPhotos.length;
      $[41] = validPhotos.length;
      $[42] = zoomOnClick;
      $[43] = t18;
    } else {
      t18 = $[43];
    }
    t17 = uniqueCarouselPhotos.map(t18).filter(Boolean);
    $[12] = brokenImages;
    $[13] = displayShownIn;
    $[14] = enableCrops;
    $[15] = hasMoreThanMaxPhotos;
    $[16] = isConfigFlipped;
    $[17] = isConfigurationGallery;
    $[18] = isEditOrder;
    $[19] = isHero;
    $[20] = productName;
    $[21] = scrollDownToCustomizer;
    $[22] = showDecideLaterOverlay;
    $[23] = standardRatio;
    $[24] = uniqueCarouselPhotos;
    $[25] = validPhotos.length;
    $[26] = zoomOnClick;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  const slides = t17;
  let t18;
  if ($[44] !== handleSlideChange || $[45] !== slides) {
    t18 = <CSSScrollSnapCarousel height="medium" onSlideChange={handleSlideChange} slides={slides} />;
    $[44] = handleSlideChange;
    $[45] = slides;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  const t19 = !displayShownIn;
  const t20 = !showDecideLaterOverlay;
  let t21;
  if ($[47] !== displayShownIn || $[48] !== showDecideLaterOverlay || $[49] !== t19 || $[50] !== t20) {
    t21 = classNames("absolute right-4 top-4 z-[1]", {
      "justify-between left-4": t19,
      "justify-end": displayShownIn,
      flex: t20,
      "!hidden": showDecideLaterOverlay
    });
    $[47] = displayShownIn;
    $[48] = showDecideLaterOverlay;
    $[49] = t19;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== displayShownIn || $[53] !== headerLeft) {
    t22 = !displayShownIn ? <div className="pointer-events-none">{!!headerLeft && headerLeft}</div> : null;
    $[52] = displayShownIn;
    $[53] = headerLeft;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== showARIcon) {
    t23 = showARIcon && <PDPView3DButton />;
    $[55] = showARIcon;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== isConfigurationGallery || $[58] !== selectedCarouselIndex || $[59] !== videoId || $[60] !== zoomOnClick) {
    t24 = !!zoomOnClick && !(selectedCarouselIndex === 1 && videoId) && <PDPMobileGalleryZoomIcon inverted={isConfigurationGallery} onClick={() => {
      setIsFullScreenGalleryOpen(true);
    }} />;
    $[57] = isConfigurationGallery;
    $[58] = selectedCarouselIndex;
    $[59] = videoId;
    $[60] = zoomOnClick;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] !== showFavoriteButton) {
    t25 = showFavoriteButton && <PDPFavoriteButton size="sm" className="ml-0" />;
    $[62] = showFavoriteButton;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  const t26 = !!rightButtons && rightButtons;
  let t27;
  if ($[64] !== t25 || $[65] !== t26) {
    t27 = <div className="flex flex-col gap-2">{t25}{t26}</div>;
    $[64] = t25;
    $[65] = t26;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  let t28;
  if ($[67] !== t23 || $[68] !== t24 || $[69] !== t27) {
    t28 = <div className="flex [&_>_*_+_*]:ml-2.5">{t23}{t24}{t27}</div>;
    $[67] = t23;
    $[68] = t24;
    $[69] = t27;
    $[70] = t28;
  } else {
    t28 = $[70];
  }
  let t29;
  if ($[71] !== t21 || $[72] !== t22 || $[73] !== t28) {
    t29 = <div className={t21}>{t22}{t28}</div>;
    $[71] = t21;
    $[72] = t22;
    $[73] = t28;
    $[74] = t29;
  } else {
    t29 = $[74];
  }
  let t30;
  if ($[75] !== t18 || $[76] !== t29) {
    t30 = <div className="relative">{t18}{t29}</div>;
    $[75] = t18;
    $[76] = t29;
    $[77] = t30;
  } else {
    t30 = $[77];
  }
  let t31;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = () => {
      setIsFullScreenGalleryOpen(false);
    };
    $[78] = t31;
  } else {
    t31 = $[78];
  }
  let t32;
  if ($[79] !== displayShownIn || $[80] !== isEditOrder || $[81] !== isFullScreenGalleryOpen || $[82] !== productName || $[83] !== selectedCarouselIndex || $[84] !== validPhotos) {
    t32 = <BrowserOnly><PDPFullScreenGallery isEditOrder={isEditOrder} isOpen={isFullScreenGalleryOpen} photos={validPhotos} initialSelectedPhotoIndex={selectedCarouselIndex} onClose={t31} productName={productName} displayShownIn={displayShownIn} /></BrowserOnly>;
    $[79] = displayShownIn;
    $[80] = isEditOrder;
    $[81] = isFullScreenGalleryOpen;
    $[82] = productName;
    $[83] = selectedCarouselIndex;
    $[84] = validPhotos;
    $[85] = t32;
  } else {
    t32 = $[85];
  }
  let t33;
  if ($[86] !== t30 || $[87] !== t32) {
    t33 = <>{t30}{t32}</>;
    $[86] = t30;
    $[87] = t32;
    $[88] = t33;
  } else {
    t33 = $[88];
  }
  return t33;
};
PDPMobileCarousel.propTypes = {
  displayShownIn: PropTypes.bool,
  enableCrops: PropTypes.bool,
  headerLeft: PropTypes.node,
  isConfigFlipped: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  isHero: PropTypes.bool,
  maxPhotos: PropTypes.number,
  onAfterSlide: PropTypes.func,
  onDimensionsIconClick: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    src: PropTypes.string,
    type: PropTypes.string
  })),
  productName: PropTypes.string,
  rightButtons: PropTypes.node,
  showARIcon: PropTypes.bool,
  showDecideLaterOverlay: PropTypes.bool,
  showFavoriteButton: PropTypes.bool,
  videoId: PropTypes.string,
  zoomOnClick: PropTypes.bool
};
export default PDPMobileCarousel;
function _temp() {}